<template>
  <div class="row" style="margin-top: 40px; margin-left: 5px; margin-right: 5px;">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('paymentPage.invoiceList')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="payment_page" v-if="JSON.parse(this.$session.get('userData')).is_allowed_to_see_bills">
      <div class="card">
        <div class="card-content">
          <div class="table-container">
            <el-table class=""
                      v-loading="loading"
                      :data="tableData"
                      :current-page="1"
                      :page-size="pagesize"
                      style="width: 100%; background: #fff"
                      >
              <el-table-column
                :label="$t('paymentPage.invoice')"
                :min-width="80">
                <template slot-scope="props">
                  <p :class="props.row.payed ? '' : 'unpaid'">{{props.row.series}}{{props.row.number}}</p>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('paymentPage.total')"
                :min-width="80">
                <template slot-scope="props">
                  <p :class="props.row.payed ? '' : 'unpaid'"><span>{{props.row.total}}</span> <span>{{props.row.currency}}</span></p>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('paymentPage.forDate')">
                <template slot-scope="props">
                  <p :class="props.row.payed ? '' : 'unpaid'"><span>{{convertToMounth(props.row.for_month_date)}}</span></p>
                </template>
              </el-table-column>   
              <el-table-column
                :label="$t('paymentPage.payed')">
                <template slot-scope="props">
                  <p v-if="props.row.payed" style="color:green;">{{$t('general.yes')}}</p>
                  <p v-else :class="props.row.payed ? '' : 'unpaid'">{{$t('general.no')}}</p>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('paymentPage.transaction')">
                <template slot-scope="props">
                  <p :class="props.row.payed ? '' : 'unpaid'"><span>{{props.row.transaction_id}}</span></p>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('paymentPage.payLink')">
                <template slot-scope="props">
                  <p v-if="props.row.link && props.row.link != '' && !props.row.payed">
                    <a :href="props.row.link" target="_blank">
                      <button>{{$t('paymentPage.pay')}}</button>
                    </a>
                  </p>
                </template>
              </el-table-column>        
              <el-table-column
                :label="$t('paymentPage.viewInvoice')">
                <template slot-scope="props">
                  <p v-if="1">
                    <a :href="showInvoice(props.row.series, props.row.number)" target="_blank">
                      <button :class="props.row.payed ? 'dwnBtn' : 'dwnBtn unpaid'">{{$t('paymentPage.download')}}</button>
                    </a>
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import DataTables from 'vue-data-tables'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

  Vue.use(DataTables)
  export default {
    components: {
      // GeneralTopBar
    },
    data () {
      return {
        loading: true,
        tableData: [],
        pagesize: 10,
        company_id: null
      }
    },
    created () {
      this.company_id = this.$session.get('selectedCompany')
      this.getData()
    },
    methods: {
      getData () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }
        this.apiRequest('/show-invoice-from-company', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data.invoices
            this.loading = false
            // scuze...o mizerie :(
            setTimeout(() => {
              this.pagesize = 999
            }, 100)
          }
        })
      },
      convertToMounth (date) {
        var dateObj = new Date(date)
        var month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
        return month + '-' + dateObj.getFullYear()
      },
      showInvoice (series, number) {
        var link = '?number=' + btoa(number)
        link += '&series=' + btoa(series)
        link += '&pass=zGCoxq92n24P'
        return process.env.API_BASE_URL + '/show-invoice' + link
      }
    }
  }
</script>
<style lang="scss">
  .payment_page .pagination-bar {
    display: none;
  }
  .payment_page th {
    font-size: 18px;
  }
  .payment_page .dwnBtn {
    border-radius: 20px;
    box-sizing: border-box;
    border-width: 1px;
    background-color: transparent;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 7px 18px;
    border-color: #66615B;
    color: #66615B;
    -webkit-transition: all 150ms linear;
    -moz-transition: all 150ms linear;
    -o-transition: all 150ms linear;
    -ms-transition: all 150ms linear;
    transition: all 150ms linear;
    background: #027e02;
    color: #fff;
    &.unpaid {
      background: red;
      color: #fff;
    }
  }
  .payment_page .unpaid {
    color: red;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Payment/Payment.vue